import loadingSpinner2 from '../../Res/loadingSpinner2.svg';

const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgb(153 153 153 / 70%)',
    zIndex: 9999,
  },
};

function GlobalLoadingSpinner() {
  return (
    <div style={styles.spinnerContainer}>
      <img src={loadingSpinner2} />
    </div>
  );
}

export default GlobalLoadingSpinner;
